import React from 'react';
import { Descriptions, Button, Card } from 'antd';

import { getUserRoleByRoles } from '@services/utils';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Navigation } from '@constants/Navigation';
import { useHistory, useParams } from 'react-router-dom';
import api from '@services/api';
import { UserResponse } from '@openapi';

const InfoUserModal = () => {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = React.useState<UserResponse>();
  const history = useHistory();

  React.useEffect(() => {
    if (id) {
      api.administration.getUserById(id).then((data) => {
        setUser(data);
      });
    }
  }, [id]);

  const onClose = () => {
    history.push(Navigation.Administration);
  };

  return (
    <Card
      title={user?.email?.toUpperCase()}
      extra={
        <Button icon={<ArrowLeftOutlined />} type="default" onClick={onClose}>
          Back to Users Page
        </Button>
      }
    >
      <Descriptions labelStyle={{ fontWeight: '500', fontSize: '16px' }} layout="horizontal" column={1} bordered>
        <Descriptions.Item label="Id">{user?.id}</Descriptions.Item>
        <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
        <Descriptions.Item label="First Name">{user?.firstName}</Descriptions.Item>
        <Descriptions.Item label="Last Name">{user?.lastName}</Descriptions.Item>
        <Descriptions.Item label="Role">{getUserRoleByRoles(user?.roles || [])}</Descriptions.Item>
        <Descriptions.Item label="Password Age">
          {user?.passwordAge ? `${user.passwordAge} days` : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Perimeter">
          {user?.etc?.perimeterNames ? user?.etc.perimeterNames.join(', ') : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Creation Date">
          {user?.createdAt ? user.createdAt.toUTCString() : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Last Modification">
          {user?.modifiedAt ? user.modifiedAt.toUTCString() : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Last Connection">
          {user?.lastAuthenticatedAt ? user.lastAuthenticatedAt.toUTCString() : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Created By">
          {user?.createdBy ? user.createdBy.toString() : '--------'}
        </Descriptions.Item>
        <Descriptions.Item label="Modified By">
          {user?.modifiedBy ? user.modifiedBy.toString() : '--------'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default React.memo(InfoUserModal);
